import { SECTIONS, type LinksSection as Doc, type PortalConfig } from '@sonder/shared'
import { useSectionEditor } from '@/data/editor'
import { Field, Input, OpenLink } from '@/ui'
import { BlockHead, NoEntities, useBrands } from './common'
import { FieldEditor } from './FieldEditor'

const DEF = SECTIONS.links

export function LinksSection({ clientId }: { clientId: string; config: PortalConfig }) {
  const ed = useSectionEditor<Doc>(clientId, 'links')
  const brands = useBrands(clientId)
  if (!ed.doc) return null
  if (brands.order.length === 0) return <NoEntities what="brands" hint="Links are per brand; add brands first." />

  return (
    <div className="grid gap-12">
      {brands.order.map((brandId) => (
        <section key={brandId} className="grid gap-6 border-t border-ink pt-6">
          <BlockHead eyebrow="Key links" title={brands.name(brandId)} />
          <div className="grid max-w-form gap-6">
            <Field label="Website" hint="Edited in Brand profiles.">
              <div className="flex items-center gap-2">
                <Input value={brands.items[brandId]?.website.value ?? ''} readOnly className="text-dim" />
                <OpenLink value={brands.items[brandId]?.website.value ?? ''} />
              </div>
            </Field>
            {DEF.fields.map((f) => (
              <FieldEditor key={f.key} editor={ed} path={`keyLinks.${brandId}.${f.key}`} def={f} />
            ))}
          </div>
        </section>
      ))}
    </div>
  )
}
